export default "__VITE_ASSET__DyrXqi05__"